<template>
  <div>
    <pageTable ref="table"
               :tableTitle="tableColumn"
               :searchData="searchData"
               :defaultPageSize="20"
               :pageSizeOptions="[20,50,100]"
               tableApi="admin/gas/getLowPriceDuplicateStations"
               :doneFunction="handleDataFormat"
    >
      <template v-slot:searchFormItem>
        <FormItem prop="station_id">
          <Input type="text" v-model="searchData.station_id" placeholder="站点ID" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="gas_name">
          <Input type="text" v-model="searchData.gas_name" placeholder="油站名称" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="platform">
          <Select v-model="searchData.platform" placeholder="渠道" clearable>
            <Option v-for="(item,key) in platform" :value="item.id" :key="key">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem prop="gas_status">
          <Select v-model="searchData.gas_status" placeholder="状态" clearable>
            <Option value="">全部</Option>
            <Option value="正常">正常</Option>
            <Option value="重复站已禁用">重复站已禁用</Option>
            <Option value="禁用">禁用</Option>
          </Select>
        </FormItem>
      </template>

      <template v-slot:otherBtn>
        <FormItem>
          <Button type="warning" @click="exportData">导出</Button>
          <Button type="default" @click="refreshData" style="margin-left: 8px">
            <Icon type="md-refresh" />
            刷新
          </Button>
        </FormItem>
      </template>
    </pageTable>

    <!-- 站点详情弹窗 -->
    <stationEditForm v-if="showStationEdit"
                     :show-edit="showStationEdit"
                     :station_id="editStationId"
                     ref="editModel"
                     @cancel-edit="showStationEdit=false"
    >
    </stationEditForm>
  </div>
</template>

<script>
import pageTable from "@/components/table/pageTable";
import stationEditForm from "./edit";

export default {
  name: "lowPriceDuplicateStations",
  components: { pageTable, stationEditForm },
  data() {
    return {
      showStationEdit: false,
      editStationId: 0,
      showMarkModal: false,
      markRemark: '',
      currentMarkRow: null,
      currentMarkStatus: '',
      platform: [],
      searchData: {
        station_id: '',
        gas_name: '',
        platform: '',
        gas_status: '',
        mark_status: '0' // 默认显示未处理
      },
      tableColumn: [
        { 
          title: '站点ID', 
          key: 'station_id', 
          align: "center", 
          width: 100,
          render: (h, params) => {
            return h('a', {
              style: {
                color: '#2d8cf0',
                cursor: 'pointer',
                textDecoration: 'underline'
              },
              on: {
                click: () => {
                  this.goToOilStation(params.row.station_id);
                }
              }
            }, params.row.station_id);
          }
        },
        { 
          title: '油站名称', 
          key: 'gas_name', 
          minWidth: 200, 
          align: "left",
          render: (h, params) => {
            return h('div', [
              h('Tag', { props: { color: 'red' } }, '低价重复'),
              h('span', { style: { marginLeft: '8px' } }, params.row.gas_name)
            ]);
          }
        },
        // {
        //   title: '地址',
        //   key: 'gas_address',
        //   minWidth: 200,
        //   align: "left",
        //   render: (h, params) => {
        //     return h('Tooltip', {
        //       props: { placement: 'top' }
        //     }, [
        //       h('div', {
        //         style: {
        //           maxWidth: '200px',
        //           overflow: 'hidden',
        //           whiteSpace: 'nowrap',
        //           textOverflow: 'ellipsis'
        //         }
        //       }, params.row.gas_address || '-'),
        //       h('div', { slot: 'content' }, params.row.gas_address || '-')
        //     ]);
        //   }
        // },
        { title: '平台', key: 'platform', align: "center", width: 120 },
        { 
          title: '当前价格', 
          key: 'price2', 
          align: "right", 
          width: 120,
          render: (h, params) => {
            return h('span', {
              style: {
                color: '#ff4d4f',
                fontWeight: '600',
                fontSize: '14px'
              }
            }, `¥${params.row.price2}`);
          }
        },
        { title: '状态', key: 'gas_status', align: "center", width: 120 },
        {
          title: '差价',
          key: 'price_diff',
          align: "right",
          width: 100,
          render: (h, params) => {
            const diff = params.row.normal_price && params.row.price2
                ? (parseFloat(params.row.normal_price) - parseFloat(params.row.price2)).toFixed(2)
                : '-';
            return h('span', {
              style: {
                color: diff !== '-' && parseFloat(diff) > 0 ? '#ff4d4f' : '',
                fontWeight: diff !== '-' && parseFloat(diff) > 0 ? '600' : ''
              }
            }, diff !== '-' ? `¥${diff}` : '-');
          }
        },
        { 
          title: '最低价更新时间', 
          key: 'lowest_price_update_time', 
          align: "center", 
          width: 160,
          render: (h, params) => {
            return h('span', params.row.lowest_price_update_time || '-');
          }
        },
        { 
          title: '对照组-正常站点ID', 
          key: 'normal_station_id', 
          align: "center", 
          width: 120,
          render: (h, params) => {
            if (!params.row.normal_station_id) {
              return h('span', '-');
            }
            return h('a', {
              style: {
                color: '#2d8cf0',
                cursor: 'pointer',
                textDecoration: 'underline'
              },
              on: {
                click: () => {
                  this.goToOilStation(params.row.normal_station_id);
                }
              }
            }, params.row.normal_station_id);
          }
        },
        { 
          title: '对照组-正常站点名称', 
          key: 'normal_gas_name', 
          minWidth: 200, 
          align: "left",
          render: (h, params) => {
            return h('div', [
              h('Tag', { props: { color: 'green' } }, '正常'),
              h('span', { style: { marginLeft: '8px' } }, params.row.normal_gas_name || '-')
            ]);
          }
        },
        { 
          title: '对照组-正常平台', 
          key: 'normal_platform', 
          align: "center", 
          width: 120,
          render: (h, params) => {
            return h('span', params.row.normal_platform || '-');
          }
        },
        { 
          title: '对照组-正常价格', 
          key: 'normal_price', 
          align: "right", 
          width: 120,
          render: (h, params) => {
            return h('span', {
              style: {
                fontWeight: '500',
                fontSize: '14px'
              }
            }, params.row.normal_price ? `¥${params.row.normal_price}` : '-');
          }
        },
        { 
          title: '最新更新时间', 
          key: 'update_time', 
          align: "center", 
          width: 160,
          render: (h, params) => {
            return h('span', params.row.update_time || '-');
          }
        },

        // {
        //   title: '操作',
        //   align: "center",
        //   width: 150,
        //   fixed: 'right',
        //   render: (h, params) => {
        //     return h('Dropdown', {
        //       props: { transfer: true },
        //       on: {
        //         'on-click': (name) => {
        //           this.handleMark(params.row, name);
        //         }
        //       }
        //     });
        //   }
        // }
      ]
    };
  },
  methods: {
    // 跳转到油站列表并筛选
    goToOilStation(station_id) {
      // 使用 router.push 跳转到柴油站点页面，并携带筛选参数
      this.$router.push({
        path: '/supplier/private',
        query: {
          station_id: station_id
        }
      });
    },
    showDetail(station_id) {
      this.showStationEdit = true;
      this.editStationId = station_id;
    },
    // 处理数据格式，确保返回正确的数组格式
    handleDataFormat(res) {
      // 后端返回格式: { data: { list: [], total: 100 }, count: 100 }
      // pageTable 需要: res.data 是数组，res.count 是总数
      if (res.data && typeof res.data === 'object' && !Array.isArray(res.data)) {
        // 提取 list 数组
        if (res.data.list && Array.isArray(res.data.list)) {
          res.data = res.data.list;
        }
        // 设置总记录数
        if (!res.count && res.data.total) {
          res.count = res.data.total;
        } else if (!res.count) {
          res.count = res.data.length || 0;
        }
      }
      console.log('处理后的数据:', res);
      return res;
    },
    async initPage() {
      let res = await this.$commonFun.postProxy('admin/common/getPageInitInfo', { type: ['platform'] });
      this.platform = res.data.platform;
    },
    exportData() {
      this.$commonFun.exportExcel(this.searchData, 'admin/gas/exportLowPriceDuplicateStations');
    },
    async refreshData() {
      try {
        // 先调用后端接口刷新最低价标识
        let res = await this.$commonFun.postProxy('admin/gas/refreshLowestPriceFlag');
        this.$commonFun.dealApiResult(res, async () => {
          this.$Message.success(res.msg || '刷新成功');
          // 刷新表格数据
          if (this.$refs.table) {
            this.$refs.table.searchAndResetPage();
          }
        });
      } catch (error) {
        console.error('刷新失败:', error);
        this.$Message.error('刷新失败，请重试');
      }
    }
  },
  mounted() {
    this.initPage();
  }
};
</script>

<style scoped>
</style>
